import { useEffect, useState, useRef } from "react"
import api from "../api/api";
import Loader from "../shared/loader";
import Pagination from "../shared/pagination";
import { saveAs } from 'file-saver';
import stringHelpers from "../../utilities/stringHelpers";
import arrayUtilities from "../../utilities/arrayUtilities";
import imageUtilities from "../../utilities/imageUtilities";
import { toDateTimeString, toDateString } from "../../utilities/dateUtilities";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {Modal} from 'react-bootstrap';
import Enums from "../../utilities/enum";
import { ErrorModal } from "../../utilities/errorModal";
import { SearchBarWithDebounce } from "../shared/searchBarWithDebounce";
import { FiltersModalTrigger } from "../shared/filtersModalTrigger";
import { AppliedFilterPill, renderTagFilterItemLabel } from "../shared/appliedFilterPill";
import appliedFiltersUtilities from "../../utilities/appliedFiltersUtilities";
import { PcnPaymentsDataFiltersModal } from "./filters-modals/PcnPaymentsDataFiltersModal";

export default function PcnPaymentsData({ sites, clients, tags, organisationId, token, location }) {
    const initialFilters = location?.state ?? {}
    const [data, setData] = useState(null);

    const [pageNumber, setPageNumber] = useState(0);
    const [similarityThreshold, setSimilarityThreshold] = useState(65);
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [sitesByClient, setSitesByClient] = useState(!stringHelpers.isNullOrEmpty(initialFilters.clientId) ? sites.filter(site => site.clientId === initialFilters.clientId) : sites)
    const [siteId, setSiteId] = useState(initialFilters.siteId ?? "");
    const [clientId, setClientId] = useState(initialFilters.clientId ?? "");
    const [selectedTags, setSelectedTags] = useState(initialFilters.tagIds ?? []);
    const [issueDateFrom, setIssueDateFrom] = useState(initialFilters.issueDateFrom ?? null);
    const [issueDateTo, setIssueDateTo] = useState(initialFilters.issueDateTo ?? null);
    const [paymentDateFrom, setPaymentDateFrom] = useState(initialFilters.paymentDateFrom ?? null);
    const [paymentDateTo, setPaymentDateTo] = useState(initialFilters.paymentDateTo ?? null);
    const [dateSearchMode, setDateSearchMode] = useState(1)
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const [showAddPayment, setShowAddPayment] = useState(false);
    const [paymentAmount, setPaymentAmount] = useState("");
    const [paymentReference, setPaymentReference] = useState("");
    const [paymentNote, setPaymentNote] = useState("");
    const [breaches, setBreaches] = useState(null)
    const [breachesPageNumber, setBreachesPageNumber] = useState(0);
    const [breachesSearchQuery, setBreachesSearchQuery] = useState("");
    const [selectedBreachId, setSelectedBreachId] = useState(null)
    const [loadingBreaches, setLoadingBreaches] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)

    const getBreaches = (pageNumber, search) => {
        setLoadingBreaches(true)
        api.getBreaches(
            (data) => {
                setBreaches(data);
                setLoadingBreaches(false);
            },
            (error) => { console.log(error); setLoadingBreaches(false) },
            search, null, null, null, null, null, null, null, null, breachesPageNumber, 0, null, null, null,
            null, null,
            null,
            organisationId,
            token, null
        )
    };

    const fetchPcnPaymentsData = (page, similarityThreshold, searchQuery, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, tagIds) => {
        setIsLoading(true);
        api.getPcnPaymentsData(
            data => { setData(data); setIsLoading(false) },
            () => setIsLoading(false),
            searchQuery, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, !stringHelpers.isNullOrEmpty(clientId) ? clientId : null, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, true, parseInt(page), parseFloat(similarityThreshold / 100), 0, tagIds, organisationId, token
        )
    }

    const handleExport = () => {
        api.getPcnPaymentsData(
            (blob, filename) => { saveAs(blob, filename) },
            () => setIsLoading(false),
            searchQuery, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, !stringHelpers.isNullOrEmpty(clientId) ? clientId : null, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, true, parseInt(pageNumber), parseFloat(similarityThreshold / 100), 1, selectedTags, organisationId, token
        )
    }

    const buildInitialAppliedFilters = () => {
        let filters = { "Date Mode": "Allow Overlap" }
        filters = appliedFiltersUtilities.applyDateRange(filters, "Issue Date", issueDateFrom, issueDateTo)
        filters = appliedFiltersUtilities.applyDateRange(filters, "Payment Date", paymentDateFrom, paymentDateTo)
        if (!stringHelpers.isNullOrEmpty(clientId)) {
            filters.Client = clients.find(item => item.id === clientId)?.name
        }
        if (!stringHelpers.isNullOrEmpty(siteId)) {
            filters.Site = sites.find(item => item.id === siteId)?.name
        }
        return appliedFiltersUtilities.applyMultiSelection(filters, "Tags", selectedTags, tags || [])
    }

    useEffect(() => {
        fetchPcnPaymentsData(0, 65, "", siteId, clientId, 1, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags);
        getBreaches(0, null)
        setAppliedFilters(buildInitialAppliedFilters())
        setShowFilterPills(true)
    }, []);

    useEffect(() => {
        fetchPcnPaymentsData(pageNumber, similarityThreshold, searchQuery, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags);
    }, [pageNumber]);

    const changepageNumber = (num) => {
        setPageNumber(num);
    };
    
    const resetFilters = () => {
        setSiteId("")
        setClientId("")
        setSitesByClient(sites)
        setIssueDateFrom(null)
        setIssueDateTo(null)
        setPaymentDateFrom(null)
        setPaymentDateTo(null)
        setDateSearchMode(1)
        setSelectedTags([])
        setAppliedFilters({
            "Date Mode": "Allow Overlap"
        })
        setShowFilterPills(true)
        setPageNumber(0);
        fetchPcnPaymentsData(0, similarityThreshold, searchQuery, "", "", 1, null, null, null, null, []);
    }

    const changeSimilarityThresholdTimeout = useRef();
    const changeSimilarityThreshold = (newThreshold) => {
        setSimilarityThreshold(Number(newThreshold));

        if (changeSimilarityThresholdTimeout.current) {
            clearTimeout(changeSimilarityThresholdTimeout.current);
            changeSimilarityThresholdTimeout.current = null;
        }

        changeSimilarityThresholdTimeout.current = setTimeout(() => {
            fetchPcnPaymentsData(pageNumber, newThreshold, searchQuery, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags);
        }, 1000);
    };

    const resetSimilarityThreshold = (query = searchQuery, page = pageNumber) => {
        if (changeSimilarityThresholdTimeout.current) {
            clearTimeout(changeSimilarityThresholdTimeout.current);
            changeSimilarityThresholdTimeout.current = null;
        }
        setSimilarityThreshold(65);
        fetchPcnPaymentsData(page, 65, query, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags);
    };

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "Client":
                setClientId("")
                setSitesByClient(sites)
                setSiteId("")
                fetchPcnPaymentsData(0, similarityThreshold, searchQuery, "", "", dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags)
                break
            case "Site":
                setSiteId("")
                fetchPcnPaymentsData(0, similarityThreshold, searchQuery, "", clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags)
                break
            case "Issue Date Range":
            case "Issue Date From":
            case "Issue Date To":
                setIssueDateFrom(null)
                setIssueDateTo(null)
                fetchPcnPaymentsData(0, similarityThreshold, searchQuery, siteId, clientId, dateSearchMode, null, null, paymentDateFrom, paymentDateTo, selectedTags)
                break
            case "Payment Date Range":
            case "Payment Date From":
            case "Payment Date To":
                setPaymentDateFrom(null)
                setPaymentDateTo(null)
                fetchPcnPaymentsData(0, similarityThreshold, searchQuery, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, null, null, selectedTags)
                break
            case "Date Mode":
                setDateSearchMode(1)
                fetchPcnPaymentsData(0, similarityThreshold, searchQuery, siteId, clientId, 1, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags)
                break
            case "Tags":
                setSelectedTags([])
                fetchPcnPaymentsData(0, similarityThreshold, searchQuery, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, [])
                break
            default:
                break
        }
        setPageNumber(0)
    }

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel.startsWith("Issue Date")) {
                updatedFilters["Issue Date Range"] = null
                updatedFilters["Issue Date From"] = null
                updatedFilters["Issue Date To"] = null
            } else if (closedLabel.startsWith("Payment Date")) {
                updatedFilters["Payment Date Range"] = null
                updatedFilters["Payment Date From"] = null
                updatedFilters["Payment Date To"] = null
            } else if (closedLabel === "Client") {
                updatedFilters.Client = null
                updatedFilters.Site = null
            } else if (closedLabel === "Date Mode") {
                updatedFilters["Date Mode"] = "Allow Overlap"
            } else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                fetchPcnPaymentsData(0, similarityThreshold, searchQuery, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, remainingIds)
                break
            default:
                break
        }
        setPageNumber(0)
    }

    const fetchSiteUrl = (id) => {
        const site = sitesByClient.find(item => item.id === id)
        if (site !== undefined) {
            return `/organisation/${ organisationId }/client/${ site.clientId }/site/${ id }`;
        }
    }

    const changeBreachesSearchQueryTimeout = useRef();
    const changeBreachesSearchQuery = (query) => {
        setBreachesSearchQuery(query);

        if (changeBreachesSearchQueryTimeout.current) {
            clearTimeout(changeBreachesSearchQueryTimeout.current);
            changeBreachesSearchQueryTimeout.current = null;
        }

        changeBreachesSearchQueryTimeout.current = setTimeout(() => {
            getBreaches(breachesPageNumber, query)
        }, 1000)
    }

    const changeBreachesPageNumber = (num) => {
        setBreachesPageNumber(num);
        getBreaches(num, breachesSearchQuery)
    }

    const getSimilarityMarkup = (value) => {
        let similarityClass = value > 0.99 ? "bg-success" : (value > 0.6 ? "bg-warning" : "bg-danger");

        return (
            <div class="progress" style={ { minWidth: "100px" } }>
                <div
                    class={ `progress-bar text-left pl-1 ${ similarityClass }` }
                    role="progressbar"
                    style={ { width: `${ value * 100 }%` } }
                    aria-valuenow={ value }
                    aria-valuemin="0"
                    aria-valuemax="100"
                >{ stringHelpers.formatDecimal((value * 100), 0) }%
                </div>
            </div>
        )
    }

    const savePayment = function () {
        api.addBreachPayment(
            data => {
                setShowAddPayment(false)
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    fetchPcnPaymentsData(pageNumber, similarityThreshold, searchQuery, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags)
                }
            },
            (error) => { 
                console.log(error)
                setShowAddPayment(false)
                setErrorMessage(error.message)
            },
            selectedBreachId,
            paymentAmount,
            paymentReference,
            paymentNote,
            organisationId,
            token
        )
        resetPaymentModalValues()
    }

    const resetPaymentModalValues = () => {
        setBreachesSearchQuery(null)
        setSelectedBreachId(null)
        setBreachesPageNumber(0)
        setBreachesSearchQuery(null)
        setPaymentAmount("")
        setPaymentReference("")
        setPaymentNote("")
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h5 className="mb-1 d-flex align-items-center">
                                PCN Payments
                            </h5>
                            <div className="d-flex justify-content-between mt-1">
                                <div className="d-flex align-items-center">
                                    <div className='mr-2'>
                                        <SearchBarWithDebounce
                                            onSearchQueryChange={ query => {
                                                setSearchQuery(query)
                                                setPageNumber(0)
                                                if (stringHelpers.isNullOrEmpty(query)) {
                                                    resetSimilarityThreshold(query, 0)
                                                }
                                                else {
                                                    fetchPcnPaymentsData(0, similarityThreshold, query, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags)
                                                }
                                            } }
                                        />
                                    </div>
                                    <div className='d-flex align-items-center bg-white mr-3'>
                                        <div className='d-flex align-items-center px-2' style={ { height: "34px" } }>
                                            <label className='m-0 mr-3 text-nowrap'>Similarity: { similarityThreshold }%</label>
                                            <input
                                                class="form-range"
                                                type="range"
                                                min="0"
                                                max="100"
                                                value={ similarityThreshold }
                                                onChange={ (e) => changeSimilarityThreshold(e.target.value) }
                                            />
                                        </div>
                                    </div>
                                    <div className='mr-2'>
                                        <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                    </div>
                                </div>
                                <div className="d-flex align-items-start mt-1">
                                    <button
                                        className="btn btn-success btn-sm mr-1 ml-1 nowrap"
                                        onClick={ () => setShowAddPayment(true) }>
                                        <i className="fas fa-plus mr-1"></i>Add
                                    </button>
                                    <button
                                        className="btn btn-primary btn-sm mr-1 ml-1 nowrap"
                                        onClick={ () => fetchPcnPaymentsData(pageNumber, similarityThreshold, searchQuery, siteId, clientId, dateSearchMode, issueDateFrom, issueDateTo, paymentDateFrom, paymentDateTo, selectedTags) }>
                                        <i className="fas fa-redo mr-1"></i>Refresh
                                    </button>
                                    <button
                                        className="btn btn-dark btn-sm mr-1 ml-1 nowrap"
                                        onClick={ () => handleExport() }>
                                        <i className="fas fa-download mr-1"></i>Export
                                    </button>
                                </div>
                            </div>
                        </div>
                        {
                            showFilterPills && appliedFilters &&
                            <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                {
                                    Object.entries(appliedFilters).map(
                                        ([label, value]) => {
                                            const resettable = label === "Date Mode"
                                            return <AppliedFilterPill
                                                key={ label }
                                                label={ label }
                                                value={ value }
                                                isResettable={ resettable }
                                                renderItemLabel={ renderTagFilterItemLabel }
                                                onTextClick={ () => setShowFiltersModal(true) }
                                                onCloseClick={ handleFilterPillClose }
                                                onRemoveItem={ handleFilterPillItemRemove }
                                            />
                                        }
                                    )
                                }
                                {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => resetFilters()}>Reset all filters</button>}
                            </div>
                        }
                        { isLoading
                            ? <Loader />
                            : <div className="card-body bg-white border-top details-container p-0 overflow-auto">
                                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>VRM</th>
                                            { !arrayUtilities.isNullOrEmpty(data?.items) && data?.items[0].similarity !== null && <th>Similarity</th> }
                                            <th>PCN Reference</th>
                                            <th>Site Name</th>
                                            <th className="text-right">Amount</th>
                                            <th>Issue Date</th>
                                            <th>Payment Date</th>
                                            <th>Reference</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            !arrayUtilities.isNullOrEmpty(data?.items) &&
                                            data.items.map((item, index) =>
                                                <tr key={ index } className={ item.isDeleted ? 'text-decoration-line-through text-muted' : '' }>
                                                    <td>
                                                        {
                                                            item.paymentProvider !== 1
                                                            ? <span className="logo-container">{ imageUtilities.fetchPcnPaymentProviderLogo(item.paymentProvider) }</span>
                                                            : <>Manual</>
                                                        }
                                                    </td>
                                                    <td>
                                                        <span className="number-plate-link"><h6 className={`mb-0 small-number-plate ${item.isDeleted && "text-muted"}`}>{ item.vrm }</h6></span>
                                                    </td>
                                                    { data?.items[0].similarity !== null && <td>{ getSimilarityMarkup(item.similarity) }</td> }
                                                    <td>
                                                        <Link to={`/organisation/${organisationId}/breach/${item.breachId}`}><h6 className={`m-0 ${item.isDeleted && "text-muted"}`}>{ item.reference }</h6></Link>
                                                    </td>
                                                    <td>
                                                        <Link to={fetchSiteUrl(item.siteId)}><h6 className={`m-0 ${item.isDeleted && "text-muted"}`}>{ item.siteName }</h6></Link>
                                                    </td>
                                                    <td className="text-right">{ stringHelpers.formatDecimal(item.amount, 2, "£") }</td>
                                                    <td>{ toDateString(item.issueDate) }</td>
                                                    <td>{ toDateTimeString(item.paymentDate) }</td>
                                                    <td>{item.paymentProviderId}</td>
                                                </tr>)
                                        }
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>


                    <div className="d-flex justify-content-center row align-items-center pt-2">
                        <div className="col-auto align-items-center">
                            <Pagination totalResults={ data?.totalCount } currentPage={ pageNumber } changePageNumber={ changepageNumber } />
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="breaches-modal" size='xl' fullscreen scrollable show={ showAddPayment } onHide={() => {
                setShowAddPayment(false)
                resetPaymentModalValues()
            }}>
                <Modal.Header>
                    <Modal.Title>
                        Add a payment
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-2">
                        <div className="col-12 col-md-2">
                            <p className="font-weight-semi-bold  mt-1 mb-2">Breach</p>
                        </div>
                        <div className="col-12 col-md-10">
                            <div className='d-flex w-100 mb-3 mt-1'>
                                <div className="input-group">
                                    <input name="breach-search" className="form-control" value={ breachesSearchQuery } type="text" autoFocus={ true } placeholder="Search..." onChange={ e => changeBreachesSearchQuery(e.target.value) } />
                                    <div className="input-group-append">
                                        <button className="btn btn-falcon-default" onClick={ () => changeBreachesSearchQuery("") }><i className="fas fa-times mr-1"></i>Clear</button>
                                    </div>
                                </div>
                                <div className="">
                                    <div className="text-nowrap">
                                        <button className="btn btn-danger ml-2" onClick={ () => setSelectedBreachId(null) }><i className="fas fa-undo mr-1"></i>Clear Breach Selection</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body bg-light border-top details-container p-0 breach-selector-table">
                                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th className='text-nowrap'>Reference</th>
                                            <th>VRM</th>
                                            <th>Site</th>
                                            <th>Contravention</th>
                                            <th className="text-center text-nowrap">Date</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { loadingBreaches ? <><tr>
                                            <td colSpan={ 7 }>
                                                <Loader />
                                            </td></tr></>
                                            : <>
                                                { breaches && !arrayUtilities.isNullOrEmpty(breaches.items) && breaches.items.map(breach => {
                                                    return (
                                                        <tr className="cursor-pointer" key={ breach.id } onClick={ () => { setSelectedBreachId(breach.id) } }>
                                                            <td>
                                                                <input checked={selectedBreachId && selectedBreachId === breach.id} onClick={() => setSelectedBreachId(breach.id)} type="radio" name="payment-breach-selection" />
                                                            </td>
                                                            <td><h6 className="mb-0 cursor-pointer">{ breach.referenceNumber }</h6></td>
                                                            <td><h6 className="mb-0 small-number-plate">{ breach.vrm }</h6></td>
                                                            <td><h6>{ breach.siteName }</h6></td>
                                                            <td>{ breach.contraventionName }</td>
                                                            <td className="text-center">{ !stringHelpers.isNullOrEmpty(breach.timestamp) && toDateString(breach.timestamp) }</td>
                                                            <td>{ Enums.BreachStatus[breach.breachStatus] }</td>
                                                        </tr>
                                                    )
                                                }) }
                                            </> }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-auto ">
                                    <Pagination totalResults={ breaches?.totalCount } currentPage={ breachesPageNumber } changePageNumber={ changeBreachesPageNumber } />
                                </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-12 col-md-2">
                            <p className="font-weight-semi-bold  mt-1 mb-2">Amount</p>
                        </div>
                        <div className="col-12 col-md-10">
                            <div className="form-group mb-0">
                                <input className="form-control" type='number' step="0.01" value={ paymentAmount } onChange={ (e) => setPaymentAmount(e.target.value) } />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-12 col-md-2">
                            <p className="font-weight-semi-bold  mt-1 mb-2">Reference</p>
                        </div>
                        <div className="col-12 col-md-10">
                            <div className="form-group mb-0">
                                <input className="form-control" type='text' value={ paymentReference } onChange={ (e) => setPaymentReference(e.target.value) } />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-2">
                            <p className="font-weight-semi-bold  mt-1 mb-2">Note</p>
                        </div>
                        <div className="col-12 col-md-10">
                            <div className="form-group mb-0">
                                <textarea rows={ 3 } className="form-control" value={ paymentNote } onChange={ (e) => setPaymentNote(e.target.value) } />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-sm btn-danger mt-1" onClick={ () => {
                        setShowAddPayment(false)
                        resetPaymentModalValues()
                    } }>Cancel</button>
                    <button className="btn btn-sm btn-success mt-1" disabled={ isNaN(paymentAmount) || paymentAmount <= 0 && stringHelpers.isNullOrEmpty(paymentReference) || stringHelpers.isNullOrEmpty(selectedBreachId) } onClick={ savePayment }>Save</button>
                </Modal.Footer>
            </Modal>

            {!stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={errorMessage} onHide={() => setErrorMessage(null)} />}
            {
                showFiltersModal &&
                <PcnPaymentsDataFiltersModal
                    showModal={ showFiltersModal }
                    handleClose={ () => setShowFiltersModal(false) }
                    handleConfirm={ (draftFilters) => {
                        setIssueDateFrom(draftFilters.issueDateFrom)
                        setIssueDateTo(draftFilters.issueDateTo)
                        setPaymentDateFrom(draftFilters.paymentDateFrom)
                        setPaymentDateTo(draftFilters.paymentDateTo)
                        setDateSearchMode(draftFilters.dateSearchMode)
                        setClientId(draftFilters.clientId)
                        setSiteId(draftFilters.siteId)
                        setSitesByClient(draftFilters.sitesByClient)
                        setSelectedTags(draftFilters.selectedTags)
                        setAppliedFilters(draftFilters.appliedFilters)
                        setShowFilterPills(true)
                        setShowFiltersModal(false)
                        setPageNumber(0)
                        fetchPcnPaymentsData(0, similarityThreshold, searchQuery, draftFilters.siteId, draftFilters.clientId, draftFilters.dateSearchMode, draftFilters.issueDateFrom, draftFilters.issueDateTo, draftFilters.paymentDateFrom, draftFilters.paymentDateTo, draftFilters.selectedTags)
                    } }
                    initialIssueDateFrom={ issueDateFrom }
                    initialIssueDateTo={ issueDateTo }
                    initialPaymentDateFrom={ paymentDateFrom }
                    initialPaymentDateTo={ paymentDateTo }
                    initialDateSearchMode={ dateSearchMode }
                    initialClientId={ clientId }
                    initialSiteId={ siteId }
                    initialSitesByClient={ sitesByClient }
                    initialSelectedTags={ selectedTags }
                    initialAppliedFilters={ appliedFilters }
                    clients={ clients }
                    sites={ sites }
                    tags={ tags || [] }
                    organisationId={ organisationId }
                    token={ token }
                    key="pcn-payments-data-filters-modal"
                />
            }
        </div>
    )
}